// Propagate down and init event
// There is no native chaining between main contents and alt-page
// is not done here but should be done in the activating top section (ex: toggle)
$(document).ready(function() {
  $(
    '.base-page, .alt-page'
  ).on('init-page', function(event, params) {
    event.stopPropagation();
    that = this
    $(this).children('.prismic').each(function(){
      $(this).trigger('init-container', {
        page: $(that)
      });
    });
  });

  $(
    '.prismic'
  ).on('init-container', function(event, params) {
    event.stopPropagation();
    $(this).each(function(){
      $(this).trigger('init-section', params);
    });
  });

  $('.base-page').trigger('init-page', {});
});
